import { combineReducers } from "redux";
import authReducer from "./authReducer";
import settingReducer from "./settingReducer";
import pageReducer from "./pageReducer";
import pageAlertReducer from "./pageAlertReducer";
import selectOptionsReducer from "./selectOptionsReducer";
import { errorReducer } from "./errorReducer";
import { loadingReducer } from "./loadingReducer.js";
import buttonProcessingReducer from "./buttonProcessingReducer";

export default combineReducers({
  auth: authReducer,
  app_settings: settingReducer,
  page_settings: pageReducer,
  page_alert: pageAlertReducer,
  select_option: selectOptionsReducer,
  errors: errorReducer,
  loading: loadingReducer,
  button_processing: buttonProcessingReducer,
});
